import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip as ChartTooltip } from 'recharts';
import { SectionCard } from '../common/SectionCard';
import { formatAed } from '../../utils/format';
import type { ApplicationRecord, Track } from '../../types/domain';
const TRACKS: {
  id: Track;
  label: string;
  colour: string;
}[] = [{
  id: 'mega',
  label: 'Mega',
  colour: 'var(--chart-1)'
}, {
  id: 'major',
  label: 'Major',
  colour: 'var(--chart-3)'
}, {
  id: 'international',
  label: 'International',
  colour: 'var(--chart-6)'
}];
export function TrackMix({
  records
}: {
  records: ApplicationRecord[];
}) {
  const data = TRACKS.map(track => {
    const inTrack = records.filter(record => record.track === track.id);
    return {
      ...track,
      records: inTrack.length,
      support: inTrack.reduce((sum, record) => sum + record.requestedSupportAed, 0),
      meanScore: inTrack.reduce((sum, record) => sum + record.aiScore, 0) / Math.max(inTrack.length, 1)
    };
  });
  const totalRecords = data.reduce((sum, row) => sum + row.records, 0);
  return <SectionCard title="Track mix" description="Records, support and mean AI score by track" data-id="element-671" data-mp="279e2cdv2l1sj">
      <div className="relative h-40" data-id="element-672" data-mp="2c87f242j8orn">
        <ResponsiveContainer width="100%" height="100%" data-id="element-673" data-mp="2gbdofkkxyw2c">
          <PieChart data-id="element-674" data-mp="2g9srjob5n11b">
            <Pie data={data} dataKey="records" nameKey="label" innerRadius={48} outerRadius={70} paddingAngle={2} stroke="var(--card)" data-id="element-675" data-mp="2l2dhgeqxwtzk">
              {data.map(row => <Cell key={row.id} fill={row.colour} data-id="element-676" data-mp="2v2mj483pb7mc" />)}
            </Pie>
            <ChartTooltip contentStyle={{
            fontSize: 12,
            borderRadius: 4,
            border: '1px solid var(--border)'
          }} data-id="element-677" data-mp="2zxs14vtzg255" />
          </PieChart>
        </ResponsiveContainer>
        <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center" data-id="element-678" data-mp="15nof6euf3agi">
          <span className="font-mono text-xl font-semibold" data-id="element-679" data-mp="19pjejdssfdrn">{totalRecords}</span>
          <span className="text-[10px] uppercase tracking-[0.1em] text-muted-foreground" data-id="element-680" data-mp="2cyw7qmth3p6f">
            records
          </span>
        </div>
      </div>
      <ul className="mt-3 space-y-2" data-id="element-681" data-mp="2lyss4c8ty1vo">
        {data.map(row => <li key={row.id} className="grid grid-cols-[1fr_auto_auto] items-center gap-3" data-id="element-682" data-mp="2lwy58sdzzzoy">
            <span className="flex items-center gap-2 text-[12px]" data-id="element-683" data-mp="2hw5ufuph9mqk">
              <span className="h-2.5 w-2.5 rounded-sm" style={{
            background: row.colour
          }} aria-hidden="true" data-id="element-684" data-mp="2vw6wvele5285" />
              {row.label}
              <span className="text-muted-foreground" data-id="element-685" data-mp="35m06ia1z379r">({row.records})</span>
            </span>
            <span className="font-mono text-[11px] text-muted-foreground" data-id="element-686" data-mp="30ozznwxau0hl">
              {formatAed(row.support)}
            </span>
            <span className="w-10 text-right font-mono text-[11px]" data-id="element-687" data-mp="3enzmr055y7bn">
              {row.records ? row.meanScore.toFixed(1) : '—'}
            </span>
          </li>)}
      </ul>
    </SectionCard>;
}